import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { DashboardReportsUpsertDto } from 'src/app/config/shared/dto/dashboard-reports-upsert.dto';
import { ReportMenuDto } from 'src/app/config/shared/dto/report-menu.dto';
import { DashboardReportDto } from 'src/app/dashboard/shared/dashboard-report.dto';
import { ReportFileService } from 'src/app/reports/shared/report-file.service';
import { AuthService, NotificationService, TranslationService } from 'src/app/shared';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'wl-dashboard-neo-reports-config',
  templateUrl: './dashboard-neo-reports-config.component.html',
  styleUrls: ['./dashboard-neo-reports-config.component.less'],
    standalone: false
})
export class DashboardNeoReportsConfigComponent {
  public show = false;
  public reportsList: ReportMenuDto[];
  public isSaving = false;
  public hideEventReports = false;
  public hideRevenuReports = false;
  public hideAdminReports = false;
  public hideCustomReports = false;

  @Input() myDashboardReports: DashboardReportDto[];
  @Output() myReportsSaved = new EventEmitter();

  public constructor(
    private _configService: ConfigServiceService,
    private _authService: AuthService,
    private _notificationService: NotificationService,
    private _reportFileService: ReportFileService,
    private _userService: UserService
  ) {}

  public getReportMenu() {
    this._configService.getFullReportsMenu().then((data) => {
      this.reportsList = data;

      if (this.hideAdminReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Admin Reports');
      }
      if (this.hideEventReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Event Reports');
      }
      if (this.hideRevenuReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Revenue Reports');
      }

      if (this.reportsList.findIndex((x) => x.Title == 'Custom Reports') == -1 && !this.hideCustomReports) {
        this._reportFileService.getCustomReportDashboardMenu().then((customReport) => {
          this.reportsList.push(customReport);
          this.selectReports();
        });
      } else {
        this.selectReports();
      }
    });
  }

  public showEditClick() {
    this.getPermissions();
    this.getReportMenu();
    this.show = true;
  }

  public cancel() {
    this.show = false;
  }

  public selectReports() {
    if (this.myDashboardReports) {
      for (const report of this.myDashboardReports) {
        this.selectMyReport(report, this.reportsList);
      }
    }
  }

  public saveClicked() {
    this.isSaving = true;
    this._authService.getUserInfo().then((user) => {
      const upsertDto = {
        UserNum: +user.wli_usernum,
        Reports: this.getSelectedReports(this.reportsList),
      } as DashboardReportsUpsertDto;

      this._configService
        .upsertDashboardReports(upsertDto)
        .then((success) => {
          if (success) {
            this._notificationService.translateSuccess('dashboard.reports.upsert-success');
            this.show = false;
            this.myReportsSaved.emit(null);
          }
        })
        .catch((err: HttpErrorResponse) => {
          this._notificationService.error(err.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    });
  }

  private getPermissions() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Event Reports').then((result) => {
      this.hideEventReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Revenue Reports').then((result) => {
      this.hideRevenuReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Admin Reports').then((result) => {
      this.hideAdminReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Custom Reports').then((result) => {
      this.hideCustomReports = result == 0;
    });
  }

  private selectMyReport(report: DashboardReportDto, list: ReportMenuDto[]) {
    const top = list.find((x) => x.Title == report.TabName);

    if (top) {
      top.isSelected = true;
      return true;
    } else {
      for (const listReport of list) {
        if (listReport.ChildItems) {
          const found = this.selectMyReport(report, listReport.ChildItems);
          if (found) {
            return true;
          }
        }
      }
    }
  }

  private getSelectedReports(reportList: ReportMenuDto[]): ReportMenuDto[] {
    let selected = [];

    for (const report of reportList) {
      if (report.ChildItems?.length > 0) {
        selected = selected.concat(this.getSelectedReports(report.ChildItems));
      } else {
        if (report.isSelected) {
          selected.push(report);
        }
      }
    }

    return selected;
  }
}
